/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Schule_Und_Internat_Steinmuhle3Inputs */

const en__field_enum_schule_und_internat_steinmuhle3 = /** @type {(inputs: _Field_Enum_Schule_Und_Internat_Steinmuhle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marburg`)
};

const de__field_enum_schule_und_internat_steinmuhle3 = /** @type {(inputs: _Field_Enum_Schule_Und_Internat_Steinmuhle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schule und Internat Steinmühle`)
};

/**
* | output |
* | --- |
* | "Marburg" |
*
* @param {_Field_Enum_Schule_Und_Internat_Steinmuhle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_schule_und_internat_steinmuhle3 = /** @type {((inputs?: _Field_Enum_Schule_Und_Internat_Steinmuhle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Schule_Und_Internat_Steinmuhle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_schule_und_internat_steinmuhle3(inputs)
	return de__field_enum_schule_und_internat_steinmuhle3(inputs)
});
export { _field_enum_schule_und_internat_steinmuhle3 as "_field_enum_Schule_und_Internat_Steinmuhle" }